// MatchResult.jsx
import React from "react";
import { getHalfTimeOddsMatchResult } from "../functions";
import Odd from "./Odd"; // ✅ use your Odd component

const isFiniteNum = (x) => Number.isFinite(x);

const isHalfTimeMarketName = (raw) => {
  const name = String(raw || "").toUpperCase();
  if (name.includes("_H1") || name.includes("_H2")) return true;
  if (name.includes("1ST HALF") || name.includes("2ND HALF")) return true;
  if (name.includes("(1ST HALF)") || name.includes("(2ND HALF)")) return true;
  return false;
};

const extract1x2FromBt = (bt) => {
  if (!Array.isArray(bt)) return [];
  const m = bt.find((mkt) => {
    const name = String(mkt?.n ?? "").toUpperCase();
    if (isHalfTimeMarketName(name)) return false;

    return name === "1X2" || name === "FT_1X2" || name.includes("MATCH RESULT");
  });
  if (!m || !Array.isArray(m.o)) return [];
  return m.o;
};

const safeFind = (arr, names) => {
  if (!Array.isArray(arr)) return undefined;
  const set = names.map((s) => String(s).toUpperCase());
  return arr.find((o) => set.includes(String(o?.n ?? "").toUpperCase()));
};

// ✅ cell renderer using Odd for FT + optional HT line
const renderOddCell = (ftItem, htItem, keyLabel) => {
  const ftV = isFiniteNum(ftItem?.v) ? ftItem.v : undefined;
  const ftLV = isFiniteNum(ftItem?.lv) ? ftItem.lv : undefined; // ✅ from store

  const htV = isFiniteNum(htItem?.v) ? htItem.v : undefined;

  return (
    <td className="text-center" key={keyLabel}>
      {/* FT with arrows */}
      <Odd v={ftV} lv={ftLV} />

      {/* HT second line (no arrows unless you also stamp lv for HT) */}
      {isFiniteNum(htV) ? (
        <>
          <br />
          <small style={{ opacity: 0.85 }}>{Number(htV).toFixed(2)}</small>
        </>
      ) : null}
    </td>
  );
};

const MatchResult = ({ blocked, odds }) => {
  if (blocked && blocked !== 0) {
    return (
      <>
        <td className="text-center">-</td>
        <td className="text-center">-</td>
        <td className="text-center">-</td>
      </>
    );
  }

  const ft = extract1x2FromBt(odds) || [];
  const ht = getHalfTimeOddsMatchResult(odds) || [];

  const ft1 = safeFind(ft, ["1", "HOME", "H"]);
  const ftX = safeFind(ft, ["X", "DRAW", "D"]);
  const ft2 = safeFind(ft, ["2", "AWAY", "A"]);

  const ht1 = safeFind(ht, ["1", "HOME", "H"]);
  const htX = safeFind(ht, ["X", "DRAW", "D"]);
  const ht2 = safeFind(ht, ["2", "AWAY", "A"]);

  const haveAnyFT = [ft1, ftX, ft2].some((x) => isFiniteNum(x?.v));
  if (!haveAnyFT) return <td colSpan="3"></td>;

  return (
    <>
      {renderOddCell(ft1, ht1, "MR-1")}
      {renderOddCell(ftX, htX, "MR-X")}
      {renderOddCell(ft2, ht2, "MR-2")}
    </>
  );
};

export default MatchResult;
